const initialState = {
    isTopBarVisible: true,
    isNavBarVisible: true,
    isSubBarVisible: false,
    scrollToTop: false,
    activeSubBar: false
};

export default (state = initialState, action) => {
    const { type, payload } = action;
    
    switch (action.type) {
        case "LAYOUT_RESET":
            return initialState;

        case '@@redux-flash/ADD_MESSAGE':
        case 'SCROLL_TO_TOP_ENABLE':
            return {
                ...state,
                scrollToTop: true
            };
            
        case 'SCROLL_TO_TOP_DISABLE':
            return {
                ...state,
                scrollToTop: false
            };
            
        case '@@router/LOCATION_CHANGE':
            return {
                ...state,
                isSubBarVisible: action.payload.pathname.startsWith('/workspace/')
            };
            
        case 'SHOW_TOP_BAR':
            return {
                ...state,
                isTopBarVisible: true
            };
            
        case 'HIDE_TOP_BAR':
            return {
                ...state,
                isTopBarVisible: false
            };
            
        case 'SHOW_NAV_BAR':
            return {
                ...state,
                isNavBarVisible: true
            };
            
        case 'HIDE_NAV_BAR':
            return {
                ...state,
                isNavBarVisible: false
            };
            
        case 'SHOW_SUB_BAR':
            return {
                ...state,
                isSubBarVisible: true
            };
            
        case 'HIDE_SUB_BAR':
            return {
                ...state,
                isSubBarVisible: false
            };

        case 'SET_ACTIVE_SUB_BAR':
            return {
                ...state,
                activeSubBar: payload,
                isSubBarVisible: true
            }
            
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/admin/store/reducers/layout.js